<vwui-modal-header>
  Project downloaden
</vwui-modal-header>
<vwui-modal-body>
  <p class="mb-4">
    Zorg voor de juiste toestemming (ter beschikkingstelling) als je dit bestand wilt gebruiken voor een referentie bij een selectie of aanbesteding.
  </p>
  <div class="mb-4">
    <button
      class="w-full text-left p-4 pr-2 mb-2 shadow-sm rounded border border-neutral-3 hover:bg-neutral-4"
      (click)="openPrintModal()"
      >
      <div class="flex items-center">
        <vwui-icon iconName="vwui-file" class="vwui-icon-sm mr-2 shrink-0"></vwui-icon>
        <span class="flex-1">Project referentie sheet</span>
        <vwui-icon class="vwui-icon-sm text-neutral-1" iconName="vwui-chevron-right"></vwui-icon>
      </div>
    </button>
    <button class="w-full text-left p-4 pr-2 shadow-sm rounded border border-neutral-3 hover:bg-neutral-4" (click)="download()">
      <div class="flex items-center">
        <vwui-icon iconName="archive" class="vwui-icon-stroke vwui-icon-sm mr-2 shrink-0"></vwui-icon>
        <span class="flex-1">Foto's downloaden</span>
        @if (!downloading) {
          <vwui-icon class="vwui-icon-sm text-neutral-1" iconName="vwui-chevron-right"></vwui-icon>
        }
        @if (downloading) {
          <vwui-spinner></vwui-spinner>
        }
      </div>
    </button>
  </div>
</vwui-modal-body>
